export const TIPOS_DE_ASSEDIOS = {
    SEXUAL: 'SEXUAL',
    MORAL: 'MORAL',
    AMBOS: 'AMBOS',
  } as const;